
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SupportChatHeadsGrip extends Vue {
  @Prop({ type: Number, default: 0 }) unreadCount!: number;

  @Prop({ type: Boolean, default: false }) expanded!: boolean;

  @Prop({ type: Boolean, default: false }) pulse!: boolean;

  @Prop({ type: Boolean, default: false }) dragging!: boolean;
}
